import * as PopoverPrimitive from "@radix-ui/react-popover"
import * as React from "react"

import { cn } from "~/utils/helpers"

import { withPermissionGate } from "./PermissionTooltip"

const Popover = ({ ...props }: React.ComponentProps<typeof PopoverPrimitive.Root>) => {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />
}

const PopoverTrigger = withPermissionGate(
  ({ ...props }: React.ComponentProps<typeof PopoverPrimitive.Trigger>) => {
    return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />
  },
  "PopoverTrigger",
)

/** Same enter/exit as the hover cards. */
const popoverMotion = [
  "origin-(--radix-popover-content-transform-origin)",
  "data-[state=open]:overlay-enter data-[state=closed]:overlay-exit",
  "data-[side=bottom]:[--overlay-enter-y:-4px] data-[side=top]:[--overlay-enter-y:4px]",
].join(" ")

const PopoverContent = ({
  className,
  align = "center",
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) => {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        data-slot="popover-content"
        align={align}
        sideOffset={sideOffset}
        className={cn(
          popoverMotion,
          "z-50 w-72 rounded-[12px] bg-base p-4 shadow-flyout outline-hidden",
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
}

PopoverContent.displayName = PopoverPrimitive.Content.displayName

const PopoverAnchor = ({ ...props }: React.ComponentProps<typeof PopoverPrimitive.Anchor>) => {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />
}

const PopoverSection = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn("flex flex-col p-2 rounded-[12px]", className)} {...props} />
)
PopoverSection.displayName = "PopoverSection"

function PopoverHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="popover-header"
      className={cn(
        "bg-base border-b border-b-border-base flex flex-col gap-0.5 text-sm",
        className,
      )}
      {...props}
    />
  )
}
function PopoverTitle({ className, ...props }: React.ComponentProps<"h2">) {
  return <div data-slot="popover-title" className={cn("font-medium", className)} {...props} />
}
function PopoverDescription({ className, ...props }: React.ComponentProps<"p">) {
  return (
    <p
      data-slot="popover-description"
      className={cn("text-muted-foreground", className)}
      {...props}
    />
  )
}

export {
  Popover,
  PopoverContent,
  PopoverSection,
  PopoverTrigger,
  PopoverAnchor,
  PopoverHeader,
  PopoverTitle,
  PopoverDescription,
}
